import { CommonModule } from '@angular/common';
import { Component, ElementRef, forwardRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { NG_VALUE_ACCESSOR, } from '@angular/forms';
import SignaturePad from 'signature_pad';
import { MainService } from 'src/app/services/main-service.service';
import { SharedModule } from '../shared.module';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';
@Component({
  selector: 'app-generate-signature',
  templateUrl: './generate-signature.component.html',
  styleUrl: './generate-signature.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => GenerateSignatureComponent),
      multi: true,
    },
  ]
})
export class GenerateSignatureComponent implements OnInit {
  @ViewChild('textInput', { static: false }) textInput!: ElementRef<HTMLInputElement>;
  @ViewChild('textCanvas', { static: false }) textCanvas!: ElementRef<HTMLCanvasElement>;
  @ViewChild('image', { static: false }) image!: ElementRef<HTMLImageElement>;
  @ViewChild(SignaturePad, { static: false }) public signaturePad: SignaturePad;
  @ViewChildren(GenerateSignatureComponent) public sigs: QueryList<GenerateSignatureComponent>;
  @ViewChildren('sigContainer1') public sigContainer1: QueryList<ElementRef>;
  @ViewChild(SignaturePadComponent) signaturePadComponent!: SignaturePadComponent;
  @Input() canvasWidth;
  @Input() canvasHeight;
  @Input() autoFillName;
  @Input() themeChanges;
  selectedTabs = 0;
  showError = false;
  count = 0;
  count2 = 0;
  showImg = false;
  showSigns: boolean = false;
  intervalId: any;
  intervalId2: any;
  counter = 0;
  singnatureContext: any;

  public _signature: any = null;
  // public propagateChange: Function = null;
  counterboolean: boolean = true;
  signatureUrl: string;
  signature: any;

  constructor(public mainService: MainService) { }

  ngOnInit() {
    console.log(this.autoFillName);
    if(this.autoFillName) {
      requestAnimationFrame(() => {
        this.textInput.nativeElement.value = this.autoFillName; 
        this.showImg = true;
        this.count = 0;
        this.setFont();
      })
    } else {
      this.mainService.setLoader(false);
    }
  }

  setFont() {
    // this.initFontFamily();
    if (this.count === 15) {
      this.count = 0;
      return;
    }
    this.singnatureContext = this.textCanvas.nativeElement.getContext('2d');
    if (this.singnatureContext) {
      this.intervalId2 = setInterval(() => {
        let width = (this.singnatureContext && this.singnatureContext.canvas && this.singnatureContext.canvas['width']) || null
        let height = (this.singnatureContext && this.singnatureContext.canvas && this.singnatureContext.canvas['height']) || null
        if (!height || !width) return
        this.singnatureContext.clearRect(0, 0, width, height);
        this.singnatureContext.font = `italic 40px BrotherSignature${this.count == 1 ? 0 : this.count}`;
        if (this.count == 15) {
          clearInterval(this.intervalId2);
          return;
        }
        this.updateImage();
        this.count++;
        // this.setFont();
      }, 800);
    }
  }

  selectedTab(type: any) {
    if (this.selectedTabs == type) return;
    this.selectedTabs = type;
    this.mainService.is_generate_signature = type == 0 ? 1 : 0;
    if (this.selectedTabs) {
      clearInterval(this.intervalId2);
    }
    this.editSign();
  }

  editSign() {
    this.showImg = false;
    this.mainService.signature = '';
    const blob = undefined;
    this.mainService.signature = blob;
    this.singnatureContext = '';
  }

  public clear() {
    this.signaturePadComponent.clear();
    this.mainService.signature = '';
  }

  updateImage() {
    // if (!this.image.nativeElement.src) {
    //   this.initFontFamily();
    // }
    const tCtx = this.singnatureContext || this.textCanvas.nativeElement.getContext('2d');
    let value_input = this.textInput.nativeElement.value ? this.textInput.nativeElement.value : '';
    value_input = this.toTitleCase(this.textInput.nativeElement.value);
    const inputValue = value_input.replace(/^./, value_input && value_input[0].toUpperCase());
    tCtx.clearRect(0, 0, tCtx.canvas.width, tCtx.canvas.height);
    const textWidth = tCtx.measureText(inputValue).width;
    const textHeight = 80;
    tCtx.canvas.width = textWidth + 250;
    // if (tCtx.canvas.width > 500) {
    //   tCtx.canvas.width = 500;
    // }
    tCtx.canvas.height = textHeight + 200;
    tCtx.translate(tCtx.canvas.width / 2, tCtx.canvas.height / 2);
    const angle = 0;
    tCtx.rotate(angle);
    let baseFontSize = 40;
    if (inputValue && inputValue.length > 20) {
      baseFontSize = 30;
    }
    tCtx.font = `italic ${baseFontSize}px BrotherSignature${this.count2}`;
    switch (tCtx.font) {
      case `italic ${baseFontSize}px BrotherSignature7`:
      case `italic ${baseFontSize}px BrotherSignature2`:
        tCtx.font = `italic ${baseFontSize + 5}px BrotherSignature${this.count2}`;
        break;
      case `italic 30px BrotherSignature8`:
        tCtx.font = `italic 25px BrotherSignature${this.count2}`;
        break;
      case `italic 40px BrotherSignature8`:
        tCtx.font = `italic 30px BrotherSignature${this.count2}`;
        break;
      case `italic 40px BrotherSignature1`:
      case `italic 40px BrotherSignature12`:
        tCtx.font = `italic 30px BrotherSignature${this.count2}`;
        break;
    }
    tCtx.fillText(inputValue, -textWidth / 2, textHeight / 4);
    tCtx.setTransform(1, 0, 0, 1, 0, 0);
    this.image.nativeElement.src = tCtx.canvas.toDataURL();
    this.image.nativeElement.src = this.trimCanvas(this.textCanvas.nativeElement, tCtx).toDataURL();
    const dataURI = this.image.nativeElement.src;
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: 'image/jpeg'
    });
    if (this.showImg) {
      this.mainService.signature = blob;
      clearInterval(this.intervalId2);
      this.count2++;
    }
    // if (this.count2 == 1) {
    //   this.updateImage();
    // }
    if (this.count2 >= 15) {
      this.count2 = 0;
      // tslint:disable-next-line:align
    } if (this.count2 == 3 && this.counterboolean) {
      this.count2 = 0;
      this.counterboolean = false;
    }
    this.mainService.setLoader(false);
  }

  toTitleCase(str) {
    if (str.length === 0) {
      return str;
    }
    let result = str[0].toUpperCase();
    let capitalizeNext = false;

    for (let i = 1; i < str.length; i++) {
      if (str[i - 1] === '.') {
        capitalizeNext = true;
      }

      if (capitalizeNext && str[i] !== ' ') {
        result += str[i].toUpperCase();
        capitalizeNext = false;
      } else {
        result += str[i].toLowerCase();
      }
    }

    return result;
  }


  initFontFamily() {
    if (this.selectedTabs == 1) {
      this.intervalId = setInterval(() => {
        const tCtx = this.textCanvas.nativeElement.getContext('2d');
        tCtx.font = `italic 30px BrotherSignature${this.counter}`;
        this.counter++;
        if (this.counter === 16) {
          clearInterval(this.intervalId);
        }
      }, 1000);
    }
  }

  showSingImg() {
    if (!this.textInput.nativeElement.value) {
      clearInterval(this.intervalId2);
      return;
    }
    if (this.showSigns) {
      this.showImg = true;
      this.updateImage();
    }
  }

  drawComplete(dataUrl: string) {
    if (!dataUrl) {
      this.signatureUrl = '';
      this.mainService.signature = '';
      return;
    }
    this.signatureUrl = dataUrl;
    const dataURI = this.signatureUrl;
    const byteString = atob(dataURI.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: "image/jpeg",
    });
    this.mainService.signature = blob;
  }

  checkVal(event: any) {
    if (event.target.value && event.target.value.length > 0) {
      this.showSigns = true;
      const input = event.target as HTMLInputElement;
      if (input.value.length > 30) {
        input.value = input.value.slice(0, 30);
      }
    }
  }

  trimCanvas(canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D): HTMLCanvasElement {
    const width = canvas.width;
    const height = canvas.height;
    const imageData = ctx.getImageData(0, 0, width, height).data;
    let top = height, left = width, right = 0, bottom = 0;
    // Determine the bounding box of non-transparent pixels
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const index = (y * width + x) * 4;
        const alpha = imageData[index + 3]; // Alpha value

        if (alpha > 0) {
          if (x < left) left = x;
          if (x > right) right = x;
          if (y < top) top = y;
          if (y > bottom) bottom = y;
        }
      }
    }
    const trimmedWidth = right - left + 1;
    const trimmedHeight = bottom - top + 1;
    // Create a new canvas to draw the trimmed area
    const trimmedCanvas = document.createElement('canvas');
    const trimmedCtx = trimmedCanvas.getContext('2d');
    if (!trimmedCtx) return canvas;
    trimmedCanvas.width = trimmedWidth;
    trimmedCanvas.height = trimmedHeight;
    // Draw the trimmed area of the original canvas onto the new canvas
    trimmedCtx.drawImage(canvas, left, top, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight);
    return trimmedCanvas;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.textInput) {
        this.textInput.nativeElement.addEventListener('keyup', () => this.updateImage());
      }
    }, 100);
  }
  getParentDivWidth() {
    return document.getElementById('canvasDiv').offsetWidth;
  }
}
